import GenerationStatus from '../GenerationStatus';

interface SalesContractSubmissionGeneratingProps {
  generationStatus: GenerationStatus;
}

const SalesContractSubmissionGenerating = ({
  generationStatus,
}: SalesContractSubmissionGeneratingProps) => {
  if (generationStatus === GenerationStatus.Generating) {
    return 'Submitting New Contract';
  }

  if (generationStatus === GenerationStatus.Generated) {
    return 'Success';
  }
};

export default SalesContractSubmissionGenerating;
